import { Pipe, PipeTransform } from '@angular/core';
@Pipe({name: 'labelChange'})
export class DosisLabelPipe implements PipeTransform {
  transform(value: string): string {
    if (value !== undefined && value === 'Darzalex® 16 mg/kg') {
    return 'Darzalex® 8 mg/kg';
    } else {
        return value;
    }
  }
}
